import { useTranslation } from 'react-i18next'
import { multimodalApi, sortStoryboardPanels, type StoryboardPanel } from '@/api/multimodalApi'
import { EmptyMultimodalState } from './ReaderMultimodalTabs'

export function ReaderComicFlow({ panels }: { panels: StoryboardPanel[] }) {
  const { t } = useTranslation()
  const sortedPanels = sortStoryboardPanels(panels)

  if (!sortedPanels.length) {
    return <EmptyMultimodalState>{t('reader.consume.comicEmpty')}</EmptyMultimodalState>
  }

  return (
    <div className="mx-auto w-full max-w-[760px] space-y-4 px-3 py-6 sm:px-5 sm:py-8">
      {sortedPanels.map((panel, index) => (
        <figure key={panel.id} className="mx-auto w-full overflow-hidden rounded-md border bg-background">
          <img
            src={multimodalApi.panelImageUrl(panel.id)}
            alt={t('reader.consume.comicPanelAlt', { number: index + 1 })}
            loading="lazy"
            decoding="async"
            className="block h-auto w-full object-contain [content-visibility:auto]"
          />
        </figure>
      ))}
    </div>
  )
}
